<div id="urna-electronica" class="anchor"></div>
<div class="container-fluid bgWhite p-4 p-lg-5" >
    <div class="row">
        <div class="col-12 col-lg-10 p-0 p-lg-5">
            <h2 class="font-medium pb-4">- Urna Electrónica -</h2>
            <div class="container">
                <div class="row">
                    <div class="pregunta">
                        <h3 [innerHtml]="'¿Qué es Urna Electrónica?' | highlightSearch: Search"></h3>
                        <p [innerHtml]="'Es un dispositivo mediante el cual se reciben y cuentan, de manera electrónica, los votos emitidos por las y los ciudadanos durante la jornada electoral. Su sistema electrónico permite registrar automáticamente el total de votantes y los votos que cada partido y candidatura obtengan.
                        <br><br>
                        Garantiza la universalidad, libertad y la secrecía, así como los principios y valores que protege la Ley General de Instituciones y Procedimientos Electorales en la concepción tradicional del voto.' | highlightSearch: Search"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>